/* eslint-disable @typescript-eslint/no-unused-vars */
import { BenefitAlertSource } from 'shared/components/SidePanel/shared/types/enums/BenefitAlertSource';
import { createContext, SetStateAction } from 'react';
import { PanelViews } from 'shared/components/SidePanel/shared/types/enums/PanelViews';
import { IAddClientOrPatient } from 'shared/components/SidePanel/shared/types/interfaces/IAddClientOrPatient';
import { SidePanelPetParentFragment } from 'shared/types/graphql';
import { RewardsTab } from '../../components/LoyaltyProgram/components/RewardsPanel';
import { Mode } from '../../shared/types/enum/Mode';
import { ISearchPanelContext } from './ISearchPanelContext';

export default createContext<ISearchPanelContext>({
  conversationId: '',
  isSearching: false,
  setIsSearching: (isSearching: SetStateAction<boolean>): void => {
    throw new Error('(isSearching: SetStateAction<boolean>): void');
  },
  petNameSearch: '',
  setPetNameSearch: (petNameSearch: SetStateAction<string>): void => {
    throw new Error('(petNameSearch: SetStateAction<string>): void');
  },
  petParentNameSearch: '',
  setPetParentNameSearch: (petParentNameSearch: SetStateAction<string>): void => {
    throw new Error('(petParentNameSearch: SetStateAction<string>): void');
  },
  phoneNumberSearch: '',
  setPhoneNumberSearch: (phoneNumberSearch: SetStateAction<string>): void => {
    throw new Error('(setPhoneNumberSearch: SetStateAction<string>): void');
  },
  isShowInactivePetsEnabled: false,
  setIsShowInactivePetsEnabled: (isSearchCollapsed: SetStateAction<boolean>): void => {
    throw new Error('(setIsSearchCollapsed: SetStateAction<boolean>): void');
  },
  isSearchCollapsed: true,
  setIsSearchCollapsed: (isSearchCollapsed: SetStateAction<boolean>): void => {
    throw new Error('(setIsSearchCollapsed: SetStateAction<boolean>): void');
  },
  currentView: PanelViews.Search,
  currentClinicPetParentId: null,
  setCurrentClinicPetParentId: (clinicPetParentId: string): void => {
    throw new Error('setCurrentClinicPetParentId: (clinicPetParentId: string) => void');
  },
  currentClinicPetId: null,
  setCurrentClinicPetId: (clinicPetId: string): void => {
    throw new Error('setCurrentClinicPetId: (clinicPetId: string) => void');
  },
  selectedClient: null,
  selectedPatient: null,
  searchPanelMode: Mode.Default,
  setSearchPanelMode: (mode: SetStateAction<Mode>): void => {
    throw new Error('(mode: SetStateAction<Mode>): void');
  },
  viewSearch: (): void => {
    throw new Error('viewSearch: () => void');
  },
  viewClinicPetParent: (): void => {
    throw new Error('viewClinicPetParent: () => void');
  },
  viewClinicPet: (): void => {
    throw new Error('viewClinicPet: () => void');
  },
  viewBenefits: (): void => {
    throw new Error('viewBenefits: () => void');
  },
  viewAddClientOrPatient: (options?: IAddClientOrPatient): void => {
    throw new Error('viewAddClientOrPatient: (options?: IAddClientOrPatient) => void');
  },
  openBenefitsModal: false,
  setOpenBenefitsModal: (openBenefitsModal: SetStateAction<boolean>): void => {
    throw new Error('(openBenefitsModal: SetStateAction<boolean>): void');
  },
  refreshUsages: false,
  setRefreshUsages: (refreshUsages: SetStateAction<boolean>): void => {
    throw new Error('(refreshUsages: SetStateAction<boolean>): void');
  },
  invoiceId: '',
  setInvoiceId: (invoiceId: SetStateAction<string>): void => {
    throw new Error('(invoiceId: SetStateAction<string>): void');
  },
  viewBenefitSource: BenefitAlertSource.MessageComposer,
  setViewBenefitSource: (source: SetStateAction<BenefitAlertSource>): void => {
    throw new Error('(source: SetStateAction<BenefitAlertSource>): void');
  },
  removeInvoiceAttachment: false,
  setRemoveInvoiceAttachment: (removeInvoiceAttachment: SetStateAction<boolean>): void => {
    throw new Error('(removeInvoiceAttachment: SetStateAction<boolean>): void');
  },
  removeInvoice: (): void => {
    throw new Error('removeInvoice: () => void');
  },
  viewLoyaltyRewards: (): void => {
    throw new Error('viewLoyaltyRewards: () => void');
  },
  selectedLoyaltyRewardsTab: RewardsTab.RewardsHistory,
  setSelectedLoyaltyRewardsTab: (tab: SetStateAction<RewardsTab>): void => {
    throw new Error('(setSelectedLoyaltyRewardsTab: SetStateAction<RewardsTab>): void');
  },
  onAddClientClickOverride: undefined,
  setOnAddClientClickOverride: (): void => {
    throw new Error('setOnAddClientClickOverride: () => void');
  },
  resetToDefaultSearchView: (): void => {
    throw new Error('resetToDefaultSearchView: () => void');
  },
  closeSideBarPanel: (): void => {
    throw new Error('closeSideBarPanel: () => void');
  },
});
